/**
 * Register Page Component
 * 
 * Auth bridge page that redirects to Auth0 signup.
 * Public page (no authentication required).
 */

import React, { useEffect } from "react";
import { PublicLayout } from "../components/public/PublicLayout";
import { getQueryParam } from "../utils/urlParams";
import { getApiBase } from "../services/apiConfig";
import "./auth-bridge.css";

export function RegisterPage(): JSX.Element {
  useEffect(() => {
    // Validate returnTo to prevent open redirect attacks
    const validateReturnUrl = (url: string): string => {
      if (!url) return "/";
      try {
        const parsed = new URL(url, window.location.origin);
        if (parsed.origin === window.location.origin || url.startsWith("/")) {
          return url;
        }
        return "/";
      } catch {
        return url.startsWith("/") ? url : "/";
      }
    };

    // Get returnTo from query params
    // Default to "/" (home page) instead of "/app" which doesn't exist
    const rawReturnTo = getQueryParam("returnTo") || "/";
    const returnTo = validateReturnUrl(rawReturnTo);

    // Redirect to Auth0 signup via backend (uses screen_hint=signup)
    const apiBase = getApiBase();
    window.location.href = `${apiBase}/api/auth/register?return_url=${encodeURIComponent(returnTo)}`;
  }, []);

  return (
    <PublicLayout>
      <div className="auth-bridge-page">
        <div className="auth-bridge-page__container">
          <div className="auth-bridge-page__loading">
            <h1 className="auth-bridge-page__title">Redirecting to signup...</h1>
            <p className="auth-bridge-page__message">
              Please wait while we redirect you to create your account.
            </p>
          </div>
        </div>
      </div>
    </PublicLayout>
  );
}

export default RegisterPage;

